import classnames from 'classnames';
import { observer } from 'mobx-react';
import * as React from 'react';

import { InputState } from './text-field';

const styles = require('./text-input.css');

export type InputType = 'text' | 'textarea' | 'password' | 'number' | 'tel' | 'email' | 'date' | 'datetime-local';

/** Props for the component */
interface TextInputProps {
  /** Additional classes on the container */
  className?: string;
  /** HTML input type */
  type: InputType;
  /** Encapsulation of field state */
  state: InputState;
  /** Placeholder label */
  placeholder: string;
  /** Textarea sizing */
  textAreaRows?: number;
  textAreaCols?: number;
  disabled?: boolean;
}

/**
 * Component for entering text.
 */
@observer
export class TextInput extends React.Component<TextInputProps> {
  /** Renders the component */

  /** Textarea support */
  renderTextarea = (value: string, errorMsg?: string) => {
    const { placeholder, textAreaCols, textAreaRows } = this.props;
    /** Sensible defaults for rows & cols */
    const rows = textAreaRows ? textAreaRows : 10;
    const cols = textAreaCols ? textAreaCols : 50;
    return (
      <textarea
        className={classnames(styles.input, value.length > 0 && styles.nonEmpty, errorMsg && styles.error)}
        value={value}
        onChange={this.onTextAreaChange}
        placeholder={placeholder}
        rows={rows}
        cols={cols}
        disabled={this.props.disabled}
      />
    );
  };

  renderInput = (type: InputType, value: string, errorMsg?: string) => {
    return (
      <input
        className={classnames(styles.input, value.length > 0 && styles.nonEmpty, errorMsg && styles.error)}
        type={type}
        value={value}
        onChange={this.onChange}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
      />
    );
  };

  render() {
    const { type, state } = this.props;
    const errorMsg = state.errorMsg();
    const value = state.value();

    return (
      <div className={classnames(styles.textInput, this.props.className)}>
        {type === 'textarea' ? this.renderTextarea(value, errorMsg) : this.renderInput(type, value, errorMsg)}
        <div className={styles.errorMessage}>{errorMsg ? <span>{errorMsg}</span> : null}</div>
      </div>
    );
  }

  /** Callback when the text changes */
  onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.props.state.onChange(e.target.value);
  };
  onTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.props.state.onChange(e.target.value);
  };
}



// WEBPACK FOOTER //
// ./src/ui/widgets/text-input/text-input.tsx